export const onCloseWithBackdropDialog = (_, reason, onClose) =>
  reason !== 'backdropClick' ? onClose() : null;
